module.exports = __webpack_public_path__ + "img/full6-min.6ec3547e.png";